import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/shared/api';
import { ArrivalImageCanvas } from './ArrivalImageCanvas';

/** Bis zu drei Bilder eines Schritts, so klein wie im Portal-Verlauf — mit ihren Markierungen. */
export function ArrivalPreviewImages({ stepId }: { stepId: string }) {
  const api = useApi();
  const images = useQuery({
    queryKey: ['arrival-steps', stepId, 'images'],
    queryFn: () => api.arrivalSteps.images.list(stepId),
  });
  // Ein Ladefehler ist kein „ohne Bilder“.
  if (images.isError) {
    return <p className="text-fg-mute mt-2 text-xs">Bilder nicht geladen – sie fehlen hier.</p>;
  }
  const shown = images.data?.images.slice(0, 3) ?? [];
  if (shown.length === 0) return null;
  return (
    <div className="mt-2 flex gap-1.5">
      {shown.map((image) => (
        <ArrivalImageCanvas
          key={image.id}
          stepId={stepId}
          imageId={image.id}
          variant="thumb"
          annotations={image.annotations}
          className="h-14 w-20 overflow-hidden rounded-md"
        />
      ))}
    </div>
  );
}
